import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as isoCountry from 'i18n-iso-countries';

/**
 * Versão PURE do `countryPipe`. Cachea o nome do país por (código × idioma
 * atual) e só re-executa quando a entrada muda de referência. O `countryPipe`
 * original é `pure: false` — re-avalia a cada CD e explode em listas grandes
 * (351 linhas × múltiplos usos por linha).
 *
 * Trade-off: se o usuário troca o idioma no meio da sessão, as linhas já
 * renderizadas continuam no idioma antigo até a próxima navegação. Aceito —
 * troca de idioma é rara e o resto do app tem o mesmo comportamento.
 */
@Pipe({
  name: 'countryPurePipe',
  pure: true,
})
export class CountryPurePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {
    isoCountry.registerLocale(require('i18n-iso-countries/langs/en.json'));
    isoCountry.registerLocale(require('i18n-iso-countries/langs/pt.json'));
  }

  transform(country: string | number): string {
    const language = this.translateService.currentLang || 'en';
    if (language === 'pt-BR' || language === 'pt-br') {
      return isoCountry.getName(country, 'pt');
    }
    if (country === 'TWN' || country === 'TW') { return 'Taiwan'; }
    return isoCountry.getName(country, language);
  }
}
